<template>
<el-drawer
  :withHeader="false"
  :visible.sync="show">
  <div class="drawer-content" v-if="product">
    <i class="el-icon-close close-icon" @click="show = false"></i>
    <div class="product-image">
      <el-image class="image" :src="product.productMainImage" v-if="product.productMainImage" fit="cover" :preview-src-list="[product.productMainImage]" />
      <img v-else src="../../../../../assets/images/default.png" class="image" />
    </div>
    <!-- 产品信息区域 -->

    <div class="product-info">
      <!-- 直播间信息 -->
      <div class="live-info">
          <span class="live-room">
            <img v-if="product.platformLogo" :src="product.platformLogo" class="live-icon" />
            {{ product.categoryName }} {{ product.brandName }} {{ product.productName }}
          <span class="text">{{ product.activityMechanism || ''}}</span>
          </span>
      </div>
      <div class="expiry-time">
        <div class="label">活动结束时间</div>
        <div class="value">{{ computedTime(product.activityEndTime) }}</div>
      </div>
      <div>
        <div class="price-line">
          <div class="item">
            <span class="label">参考价</span>
            <span v-if="product.priceHidden" class="x-value">**</span>
            <span v-else class="value"><span class="unit">¥</span>{{ product.referencePrice || 0 }}</span>
          </div>
           <div class="item">
            <span class="label">约返佣金</span>
            <span v-if="product.priceHidden" class="x-value">**</span>
            <span v-else class="value"><span class="unit">¥</span>{{ product.promotionAmount || 0 }}</span>
          </div>
        </div>
      </div>
      <div class="content-title">分享文案（可编辑）：</div>
      <div class="edit-content" ref="shareTextRef" :contenteditable="true">
        <template v-for="(item, index) in editList">
          <div v-if="checkList.includes(item.key) && ((item.isShow && item.isShow(product)) || !item.isShow)">
          【{{ item.label }}】 {{ componentValue(item) }}
          </div>
        </template>
      </div>
      <div class="items">
        <el-checkbox-group v-model="checkList">
          <el-checkbox class="item" v-for="(item, index) in editList" :key="index" :label="item.key">{{ item.label }}</el-checkbox>
        </el-checkbox-group>
      </div>
      <div class="btns">
        <div class="btn" v-if="product.productLink" @click="toOrder">立即下单</div>
        <div class="btn" @click="$emit('toOrder')">去报单</div>
        <div class="btn" @click="copyText">复制分享文案</div>
      </div>
    </div>
  </div>
</el-drawer>
</template>
<script>
import moment from 'moment'
import { extractUrls, copyFn } from '@/utils/util'
const editList = [
  {
    label: '商品名称',
    key: ['categoryName', 'brandName', 'productName'],
    filterFn: (val) => val || '商品名称',
    active: true
  },
  {
    label: '活动机制',
    key: 'activityMechanism',
    active: true
  },
  // {
    // label: '报单ID',
    // key: 'calculationFormId',
    // active: true
  // },
  {
    label: '报单ID',
    key: 'productId',
    active: true
  },
  {
    label: '参考价',
    key: 'referencePrice',
    unit: '元',
    priceHidden: true,
    active: true
  },
  {
    label: '约返佣金',
    key: 'promotionAmount',
    unit: '元',
    priceHidden: true,
    // isShow: (data) => {
    //   return data.promotionCalcMethod && data.promotionCalcMethod === 'fixed'
    // },
    active: false
  },
  // {
  //   label: '佣金比例',
  //   key: 'promotionRate',
  //   unit: '%',
  //   isShow: (data) => {
  //     return data.promotionCalcMethod && data.promotionCalcMethod === 'rate'
  //   },
  //   active: false
  // },
  {
    label: '佣金计算方式',
    key: 'promotionCalcMethod',
    // 佣金计算方式：fixed-固定佣金，rate-比例
    filterFn: (val, data) => {
      if (data && data.priceHidden) {
        return '**'
      }
      return (val === 'fixed' ? '固定佣金' + data.promotionAmount + '元/件' : '佣金比例' + data.promotionRate + '%')
    },
    active: false
  },
  {
    label: '下单链接',
    key: 'productLink',
    active: true
  },
  {
    label: '活动结束时间',
    key: 'activityEndTime',
    type: 'dateTime',
    active: true
  },
  {
    label: '报单截止时间',
    key: 'reportEndTime',
    type: 'dateTime',
    active: true
  },
  {
    label: '下单说明',
    key: 'orderDescription',
    active: true
  }
]
export default {
  name: 'M2sBuyDrawer',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    product: {
      type: Object,
      default: null
    }
  },
  computed: {
    show: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    },
  },
  data () {
    return {
      editList, 
      checkList: editList.map(item => item.key)
    }
  },
  methods: {
    toOrder () {
      if (this.product && this.product.productLink) {
        window.open(this.product.productLink)
      }
    },
    copyText() {
      const el = this.$refs.shareTextRef
      if (!el) return
      // 获取纯文本内容，不同div块用换行分隔
      const text = Array.from(el.querySelectorAll('div'))
        .map(div => div.textContent.trim())
        .join('\n')
      copyFn(text, () => {
        this.$message({
          message: '复制成功',
          type: 'success'
        })
      })
    },
    computedTime (date) {
      if (date) {
        return moment(date).format('YYYY/MM/DD HH:mm:ss')
      }
      return '-'
    },
    componentValue(item) {
      if (Array.isArray(item.key)) {
        return item.key.map(key => this.product[key] || '').join('')
      }
      if (item.priceHidden && this.product.priceHidden) {
        return '**'
      }
      if (item.type === 'dateTime') {
        return moment(this.product[item.key]).format('YYYY/MM/DD HH:mm:ss')
      } else if (item.filterFn) {
        return item.filterFn(this.product[item.key], this.product)
      } else {
        return this.product[item.key] + (item.unit || '')
      }
      // return item.type === 'dateTime' && this.product[item.key] ? 
      //   moment(this.product[item.key]).format('YYYY/MM/DD HH:mm:ss') 
      //     : item.filterFn ? 
      //       item.filterFn(this.product[item.key], this.product) 
      //         : (this.product[item.key] || '') + (item.unit || '')
    }
  }
}
</script>
<style scoped>
.drawer-content {
  padding: 18px;
  position: relative;
}
.close-icon {
  position: absolute;
  left: 8px;
  top: 8px;
  z-index: 10;
  width: 28px;
  height: 28px;
  font-size: 16px;
  line-height: 28px;
  cursor: pointer;
  text-align: center;
  color: #fff;
  background-color: rgba(0, 0, 0, 0.4);
  border-radius: 50%;
}
.product-image {
  width: 100%;
  position: relative;
  padding-top: 100%;
}
.product-image .image {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.product-info {
  padding: 12px;
  padding-bottom: 0;
}

.live-info { 
  line-height: 22px;
  font-size: 18px;
  font-weight: 700;
  height: 44px;
  overflow: hidden;
}

.live-icon {
  margin-top: 1px;
  width: 20px;
  height: 20px;
  margin-right: 4px;
  vertical-align: middle;
  float: left;
}

.live-room {
  color: #9266FF;
  line-height: 22px;
  border-radius: 2px;
  font-size: 18px;
  overflow: hidden;
  font-weight: bold;
  float: left; 
  max-width: calc(100% - 22px);
}
.live-room .text {
  color: #000;
}
.expiry-time {
  display: flex;
  align-items: center;
  padding: 12px 0;
  color: rgba(129, 76, 49, 1);
}
.expiry-time .label {
  height: 16px;
  line-height: 16px;
  font-size: 14px;
  font-weight: bold;
  padding: 0 2px;
  background: linear-gradient(90deg, #FFE3D0 0%, #FFEDCC 100%);
}
.expiry-time .value {
  height: 14px;
  line-height: 14px;
  font-size: 14px;
  padding: 0 2px;
  border: solid 1px rgba(197, 149, 90, 1);
}
.price-line {
  display: flex;
  height: 40px;
  line-height: 40px;
  background-color: #EEE3FF;
} 
.price-line .item {
  color: #753DFF;
  padding: 0 6px;
  flex: 1;
  display: flex;
  align-items: center;
}
.price-line .item:last-child {
  background-color: #9266FF;
  color: #fff;
}
.price-line .item .label {
  padding-right: 6px;
  font-size: 12px; 
}
.price-line .item .value {
  font-size: 22px;
  font-weight: 500;
}
.price-line .item .value .unit {
  font-size: 12px;
  font-weight: normal;
}
.content-title {
  padding: 12px 0 6px 0;
  line-height: 24px;
  font-size: 14px;
  color: #000;
  font-weight: 700;
}
.edit-content {
  height: 132px;
  line-height: 20px;
  padding: 12px;
  font-size: 14px;
  overflow: scroll;
  color: rgba(104, 104, 104, 1);
  border-radius: 12px;
  border: solid 1px #9266FF;
  background-color: rgba(248, 248, 248, 1);
}
.edit-content:focus {
  outline: none;
}
.items {
  padding: 12px 0;
  line-height: 22px;
}
::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: rgba(36, 36, 36, 1);
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
  border-color: #9266FF;
  background-color: #9266FF;
}
.btns {
  display: flex;
}
.btns .btn {
  margin: 0 4px;
  flex: 1;
  border-radius: 8px;
  line-height: 44px;
  text-align: center;
  color: #fff;
  cursor: pointer;
  background: #9266FF;
}
.btns .btn&:first-child {
  margin-left: 0;
}
.btns .btn&:last-child {
  margin-right: 0;
}
.x-value {
  display: flex;
  align-items: center;
  padding-top: 2px;
  line-height: 12px;
}
</style>
